import { TranslocoPipe, provideTranslocoScope } from '@jsverse/transloco';
import { Component, Input, OnDestroy, signal } from '@angular/core';
import { DatePipe, NgTemplateOutlet } from '@angular/common';
import { MatButtonModule } from '@angular/material/button';
import { TranslocoCurrencyPipe } from '@jsverse/transloco-locale';
import { ProductPurchase } from '../../../interfaces/product.model';

// Ultima vendita del prodotto al cliente con «Applica» e lo storico delle precedenti, sotto il prezzo del foglio carrello
@Component({
  providers: [provideTranslocoScope('products')],
  selector: 'prd-purchase-history',
  imports: [TranslocoPipe, DatePipe, NgTemplateOutlet, MatButtonModule, TranslocoCurrencyPipe],
  templateUrl: './purchase-history.html',
  styleUrl: './purchase-history.scss',
})
export class PurchaseHistory implements OnDestroy {
  @Input({ required: true }) purchase!: ProductPurchase;
  @Input() unit: string | undefined;
  @Input({ required: true }) apply!: (purchase: ProductPurchase) => void;

  protected historyOpen = signal(false);
  protected applied = signal(false);
  private appliedTimer?: ReturnType<typeof setTimeout>;

  onApply() {
    this.apply(this.purchase);
    this.applied.set(true);
    clearTimeout(this.appliedTimer);
    this.appliedTimer = setTimeout(() => this.applied.set(false), 3000);
  }

  toggleHistory() {
    this.historyOpen.update(open => !open);
  }

  ngOnDestroy() {
    clearTimeout(this.appliedTimer);
  }
}
